module.exports = __webpack_public_path__ + "img/pile28803.75f3859d.png";